const FAVICON_VERSION = 'minthelp-20260421-leaf';

const buildFaviconFileName = (size, { badge = false } = {}) => {
  const badgeSegment = badge ? '-badge' : '';

  return `/${FAVICON_VERSION}-favicon${badgeSegment}-${size}.png`;
};

export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const newFileName = buildFaviconFileName(favicon.sizes[[0]], { badge: true });
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const oldFileName = buildFaviconFileName(favicon.sizes[[0]]);
        favicon.href = oldFileName;
      });
    }
  });
};
